import { TenantGeneralData } from './tenantGeneralData';

export class Tag extends TenantGeneralData {
  tagName: string;
  checked?: boolean;
  itemName?: string;

  constructor() {
    super();
  }
}
